
import React, { useState, useEffect } from "react";
import rawData from "./serviceCenters.json";

const serviceCenters = rawData
  .slice(1)
  .map((item) => ({
    id: item.A,
    state: item.B,
    district: item.C,
    name: item.D,
    address: item.E,
  }))
  .reverse();

const ITEMS_PER_PAGE = 9;

const AVPLDroneServiceCenter = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const states = [...new Set(serviceCenters.map((c) => c.state))];

  const filteredCenters = serviceCenters.filter((center) => {
    const query = searchQuery.toLowerCase().trim();

    const matchSearch =
      center.name.toLowerCase().includes(query) ||
      center.address.toLowerCase().includes(query) ||
      center.district.toLowerCase().includes(query) ||
      center.state.toLowerCase().includes(query);

    const matchState =
      !selectedState || center.state === selectedState;

    return matchSearch && matchState;
  });

  const totalCenters = filteredCenters.length;
  const totalPages = Math.ceil(totalCenters / ITEMS_PER_PAGE);

  // Reset to page 1 whenever the search or state changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, selectedState]);

  // Keep the current page valid when results change
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCenters = filteredCenters.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const showingCount = currentCenters.length;


const goToPage = (page) => {
  if (page >= 1 && page <= totalPages) {
    setCurrentPage(page);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
};


  return (
    <div className="container-fluid px-3 px-md-4 px-lg-5 py-4">
      <h4 className="fs_43 ff_inter fw-bold color_darkgray mb-4">
        Drone <span className="custom-color">Service Centers</span>
      </h4>

      {/* Filters and Count */}
      <div className="row mb-3 align-items-center">
        <div className="col-12 col-md-4 mb-2">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search centers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ fontSize: "0.85rem", padding: "6px 10px" }}
          />
        </div>

        <div className="col-12 col-md-3 mb-2">
          <select
            className="form-select form-select-sm"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            style={{ fontSize: "0.85rem", padding: "6px 10px" }}
          >
            <option value="">All States</option>
            {states.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>

        {selectedState && (
          <div className="col-6 col-md-2 mb-2">
            <button
              className="btn btn-sm btn-outline-secondary w-100"
              style={{ fontSize: "0.8rem", padding: "6px" }}
              onClick={() => setSelectedState("")}
            >
              Clear
            </button>
          </div>
        )}

        <div className="col-12 col-md mb-2 text-md-end">
          <span
            style={{
              fontSize: "0.85rem",
              color: "#555",
              fontWeight: "500",
            }}
          >
            Showing {startIndex + 1}–
            {Math.min(startIndex + showingCount, totalCenters)} of{" "}
            {totalCenters} centers
          </span>
        </div>
      </div>

      {/* Service Center Cards */}
      <div className="row g-4">
        {currentCenters.map((center) => (
          <div
            key={center.id}
            className="col-12 col-sm-6 col-md-4 col-lg-4"
          >
            <div
              className="h-100 p-3 rounded-4 bg-white"
              style={{
                boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
                transition: "all 0.3s ease",
                border: "1px solid #f1f1f1",
              }}
            >
              <h5
                className="fw-bold mb-2"
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.4",
                  color: "#1a1a1a",
                }}
              >
                {center.name}
              </h5>

              <div
                style={{
                  height: "2px",
                  width: "40px",
                  backgroundColor: "#0d6efd",
                  marginBottom: "10px",
                }}
              />

              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#555",
                  marginBottom: "8px",
                  lineHeight: "1.5",
                }}
              >
                📍 {center.address}
              </p>

              <div
                style={{
                  fontSize: "0.8rem",
                  color: "#888",
                  fontWeight: "500",
                }}
              >
                {center.district}, {center.state}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {totalCenters === 0 && (
        <div className="text-center py-5">
          <h5>No Service Centers Found</h5>
        </div>
      )}

      {/* Pagination */}
      
{totalPages > 1 && (
  <div className="d-flex justify-content-center align-items-center mt-4">
    <nav aria-label="Service center pagination">
      <ul className="pagination pagination-sm mb-0 flex-wrap justify-content-center">
        <li
          className={`page-item ${
            currentPage === 1 ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => goToPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
        </li>

        {Array.from(
          { length: totalPages },
          (_, index) => index + 1
        ).map((page) => (
          <li
            key={page}
            className={`page-item ${
              currentPage === page ? "active" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => goToPage(page)}
            >
              {page}
            </button>
          </li>
        ))}

        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  </div>
)}

    </div>
  );
};

export default AVPLDroneServiceCenter;
